import {TablePage} from "./TablePage";
import { TablePagination } from "./TablePagination";

export {TablePage , TablePagination}

